import React from "react";
import { Heading } from "../../components/ui/heading";
import { Text } from "../../components/ui/text";
import { Button } from "../../components/ui/button";
import { useAuth } from "../../context/AuthContext";

const CustomerSettings = () => {
  const { user, logout } = useAuth();

  return (
    <div className="p-6 max-w-2xl">
      <Heading className="mb-2">Account Settings</Heading>
      <Text className="text-zinc-500 mb-8">
        Manage your customer account preferences.
      </Text>

      <div className="rounded-lg border border-zinc-200 bg-white p-6 space-y-4">
        <div>
          <Text className="text-sm text-zinc-500">Account type</Text>
          <Text className="font-medium capitalize">{user?.user_type || "-"}</Text>
        </div>

        <div className="pt-2">
          <Button variant="outline" onClick={logout}>
            Log out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomerSettings;
